var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7364 7.1251H3.92458V5.5417C3.92458 3.79566 5.33323 2.3749 7.06439 2.3749C8.43542 2.3749 9.6045 3.26631 10.0311 4.50469H12.4621C11.9795 1.94314 9.74272 0 7.06439 0C4.03477 0 1.56991 2.48604 1.56991 5.5417V7.1251H0.392381C0.175458 7.1251 0 7.30206 0 7.52085V17.417C0 18.2902 0.704136 19 1.56991 19H12.5589C13.4247 19 14.1288 18.2902 14.1288 17.4166V7.52085C14.1288 7.30206 13.9533 7.1251 13.7364 7.1251ZM8.23962 15.3941C8.2519 15.5056 8.2162 15.6179 8.14171 15.7015C8.06761 15.7856 7.96088 15.8336 7.84954 15.8336H6.27963C6.16791 15.8336 6.06156 15.7856 5.98707 15.7015C5.91259 15.6179 5.87688 15.5056 5.88917 15.3941L6.13681 13.1485C5.73483 12.8534 5.49449 12.3868 5.49449 11.8749C5.49449 11.0017 6.19862 10.2915 7.06439 10.2915C7.93017 10.2915 8.6343 11.0017 8.6343 11.8749C8.6343 12.3868 8.39396 12.8534 7.99198 13.1485L8.23962 15.3941Z",
    fill: "#4A9A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.939 1.48349C17.7965 1.19655 17.4502 1.08154 17.1665 1.22366L14.8633 2.38536C14.5788 2.52902 14.4636 2.87753 14.6056 3.16447C14.7477 3.45025 15.0917 3.56758 15.3781 3.4243L17.6813 2.2626C17.9658 2.11894 18.081 1.77043 17.939 1.48349Z",
    fill: "#4A9A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6813 8.1927L15.3781 7.031C15.0936 6.88811 14.7485 7.00312 14.6056 7.29083C14.4632 7.57777 14.5788 7.92667 14.8633 8.06994L17.1665 9.23165C17.4537 9.3757 17.7977 9.25682 17.939 8.97181C18.0814 8.68487 17.9658 8.33597 17.6813 8.1927Z",
    fill: "#4A9A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4237 4.6468H15.1205C14.8022 4.6468 14.5446 4.90664 14.5446 5.22766C14.5446 5.54867 14.8022 5.80851 15.1205 5.80851H17.4237C17.742 5.80851 17.9996 5.54867 17.9996 5.22766C17.9996 4.90664 17.742 4.6468 17.4237 4.6468Z",
    fill: "#4A9A93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLocked);
export default __webpack_public_path__ + "static/media/UnLocked.f6acbbd575226464151d20c0f92415a7.svg";
export { ForwardRef as ReactComponent };